define.alias("shared/components/shared/pre-boarding/index", "media/components/shared/pre-boarding/index");